import React from 'react';
import Header from './components/Header';
import Social from './components/Social';
import About from './components/About';
import Accordions from './components/Accordions';
import TypeWriter from './components/TypeWriter';
import ImageSwiper from './components/ImageSwiper';
import Clients from './components/Clients';
import Share from './components/Share';
import Footer from './components/Footer';
import background from './images/bg.jpg';
import BottomSwiper from './components/BottomSwiper';
import ProductsSwiper from './components/ProductsSwiper';

function App() {

  var domainUrl = 'https://tanyacosmetics.netlify.app/'
  var businessName = 'Tanya';
  var businessDescription = 'Face care & Cosmetics'
  var phoneNumber = '+972544423984'
  var email = ''
  var facebookUrl = 'https://www.facebook.com/tania.natan'
  var instagram = 'tanya_facecare_cosmetics'
  var whatsapp = '+972544423984'
  var wazeUrl = 'https://www.waze.com/he/live-map/directions/%D7%94%D7%A8%D7%A6%D7%9C-35-%D7%A8%D7%97%D7%95%D7%91%D7%95%D7%AA?to=place.w.22806847.228199540.133438'
  var days = " א' - ה'"
  var hours = '17:00 - 22:00'
  //קצת עליי
  //טיפולים בקליניקה
  //לקוחות ממליצים
  //icon
  //שם ותיאור


  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };
  return (
    <div className="bg-gray-50 w-full">
      <div className=" md:w-4/5 lg:max-w-[1152px] mx-auto shadow-2xl">
        <div className="object-cover">
          <div style={divStyle}>
            <Header
              businessName={businessName}
              businessDescription={businessDescription} />

            <Social
              businessName={businessName}
              businessDescription={businessDescription}
              phoneNumber={phoneNumber}
              email={email}
              facebookUrl={facebookUrl}
              instagram={instagram}
              whatsapp={whatsapp}
              wazeUrl={wazeUrl}
              domainUrl={domainUrl}
            />
            <About />

            <Accordions
              phoneNumber={phoneNumber}
              email={email}
              days={days}
              hours={hours}
            />

            <ProductsSwiper />

            <TypeWriter
              businessName={businessName}
              businessDescription={businessDescription}
            />

          </div>
          <div style={divStyle}>
            <ImageSwiper />

            <BottomSwiper />
            <Clients
              whatsapp={whatsapp} />

            <Share domainUrl={domainUrl} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
